import { GroupsTable } from "@components/table/groups/groups-table";
import { GROUPS_TABLE_COLUMNS } from "@components/table/groups/groups-table-constants";
import { ColumnPreferencesProvider } from "@context-providers/table/column-preferences-provider";
import { BaseCompanyIdProps } from "@custom-types/base-types";
import { GroupsSortBy, GroupTypes } from "@custom-types/group-types";
import { useGroupsPageBulkActions } from "@pages/groups/use-groups-page-bulk-actions";

interface Props extends BaseCompanyIdProps {
  /** List of groups to show in table */
  groups: GroupTypes[];

  /** Flag whether it is loading some content  */
  isLoading: boolean;

  /** Current sort by value */
  sortBy: GroupsSortBy;

  /** Callback to update the sort by value */
  setSortBy: (sortBy: GroupsSortBy) => void;
}

/** Content to show for groups table */
export function GroupsPageTable({
  companyId,
  groups,
  isLoading,
  sortBy,
  setSortBy,
}: Props): JSX.Element {
  const buttonComponents = useGroupsPageBulkActions({
    groups,
  });

  return (
    <ColumnPreferencesProvider
      tableKey="groups-table"
      columns={[...GROUPS_TABLE_COLUMNS]}
      options={{
        nonConfigurableColumns: ["options"],
        defaultVisibleColumns: ["name", "members", "projects", "createdDate"],
      }}
    >
      <GroupsTable
        companyId={companyId}
        groups={groups}
        isLoading={isLoading}
        bulkActionButtons={buttonComponents}
        sortBy={sortBy}
        setSortBy={setSortBy}
      />
    </ColumnPreferencesProvider>
  );
}
